// extracted by mini-css-extract-plugin
export default {"modal":"modal__modal"};